import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import { LearnerTradeForm } from '../../etqa/program/registration/LearnerTradeForm';

const TradeRef = React.createRef();
const utils = new ViewUtils();
const toolbarRef = React.createRef();

class AddLearnerTrade extends Component {
    constructor(props) {
        super(props)
        this.state = {
            TradeDetails: {
                TradeProgrammeDescription: "",
                TradeProgrammeCode: ""
            },
            messageStyle: "message",
            id: null,
            showTable: true,
            CurrentProgramme: this.props.location.state.TradeID,
            CreateNewFlag: this.props.location.state.hideFields,
            Learner: this.props.location.state.LearnerID
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: '', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', icon: 'SaveIcon', visible: !this.props.location.state.viewOnly },
                        { id: 'tradetest', label: 'TRADE TEST', tooltip: 'Trade Test', disabled: utils.isNull(this.state.CurrentProgramme) || this.state.CurrentProgramme === 0 }
                    ]
                }
            ]
        }
    }


    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {

            this.setState({
                TradeSetupDetails: {
                    TradeProgrammeCode: values.TradeID,
                    TradeProgrammeDescription: values.TradeTitle
                },
                Learner: this.props.location.state.LearnerID
            });
        }
    }


    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("tradetest" === buttonId) {
            this.props.history.push({
                pathname: '/learnerTradeTestSearch',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    TradeID: this.state.CurrentProgramme,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.location.state.permissions,
                    viewOnly: this.props.location.state.viewOnly
                }
            });
        }
    }

    successCallback = (response) => {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    CurrentProgramme: response.EntityId,
                    CreateNewFlag: false
                }, () => { toolbarRef.current.setButtonDisabled("tradetest", utils.isNull(this.state.CurrentProgramme) || this.state.CurrentProgramme === 0); })
                    
            });
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    save() {
        let formValue = TradeRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.LearnerID;
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerTrade/LinkLearnerTrade", (response) => {
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/LearnerTradeSearch',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {
                        (this.props.location.state.hideFields) ?
                            `Learner > Link New Trade > ${this.props.location.state.learnerNames}`
                            :
                            `Learner > Update Trade > ${this.props.location.state.learnerNames}`
                    }
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    ref={toolbarRef}
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "80vh" }}>
                                    {this.state.showTable === true && (
                                        <LearnerTradeForm ref={TradeRef}
                                            viewRef={this}
                                            id={this.state.CurrentProgramme}
                                            hideFields={this.state.CreateNewFlag}
                                            editPermission={this.props.location.state.permissions}
                                            viewOnly={this.props.location.state.viewOnly}
                                            lid={this.props.location.state.LearnerID}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)} />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddLearnerTrade);
